import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  buttonChat: {
    shadowColor: neutrals.black,
    shadowOffset: { width: 9, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 100,

    borderColor: 'transparent',
    borderRadius: 100,
  },
  buttonChatInner: {
    width: 44,
    minWidth: 44,
    height: 44,
    minHeight: 44,
  },
  buttonChatInnerMobile: {
    width: 34,
    minWidth: 34,
    height: 34,
    minHeight: 34,
  },
  buttonChatMobile: {
    borderWidth: 2,
    borderColor: 'transparent',
  },
  buttonChatGradient: {
    width: 44,
    height: 44,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonChatGradientMobile: {
    width: 34,
    height: 34,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonChatOld: {
    width: 42,
    height: 42,
    minHeight: 42,
    borderRadius: 24,
    backgroundColor: 'rgba(117, 74, 250, 0.8)',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    borderWidth: 4,
    borderColor: 'transparent',
  },
  consumerAlternateColor: {
    backgroundColor: 'rgba(235, 93, 11, 0.8)',
  },
  iconChat: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconChatOld: {
    width: 32,
    height: 32,
  },
});
